import {fnResponseToNotification} from "@fndry-vue/fn-notify";

export default {
    data() {
        return {
            validated: false,
            iframe: null,
            payliance: null,
            paylianceIsProcessing: false,
            reVerificationCard: null,
            tokenizedCard: null,
            redirectAfterTokenization: true,
            isGuest: false,
            card_ssn: null,
            instanceValidated: false,
            instanceTokenized: false,
            instanceFailed: false,
            instanceVerified: false,
            tokenizer: 'basis-theory',
            configuration: null,
        }
    },
    computed: {
        activeTokenizer() {
            return this.tokenizer || 'basis-theory';
        },
        activeTokenizerIsBasisTheory() {
            return this.activeTokenizer === 'basis-theory';
        },
        activeTokenizerIsFluidpay() {
            return this.activeTokenizer === 'fluidpay';
        },
        activeTokenizerIsPayliance() {
            return this.activeTokenizer === 'payliance';
        },
        fluidpayApiKey() {
            return this.configuration?.fluidpay_public_key || '';
        },
        fluidpayApiUrl() {
            return this.configuration?.fluidpay_api_url || '';
        },
        paylianceConfiguration() {
            return this.configuration || null;
        },
    },
    mounted() {
        this.initPayliance();
    },
    methods: {
        initPayliance() {
            var url = this.isGuest ? '/api/v1/mobile/guest/cards/payliance/iframe/config' : '/api/v1/mobile/cards/payliance/iframe/config';

            this.$fnApi.call(url, 'GET').then(async response => {
                if (response.status) {
                    this.configuration = response.data;
                    if (response.data.tokenizer) {
                        this.tokenizer = response.data.tokenizer;
                    }
                }
            });
        },
        onCardTokenCreated(data) {
            console.log("Card token created", data);
            this.basisTheoryTokenizedCard = data;
            this.paylianceVerifyCardviaBT(data.id);
        },
        onSubmitting(onOrOff) {
            this.paylianceIsProcessing = onOrOff;
        },
        onCancel(){
            this.cancelling = true;
            this.$emit('onCancelled', true);
            this.redirectOnCancel();
        },
        paylianceTokenizeCardviaBT(tokenId, verifyData) {
            this.$fnApi.call('/api/v1/cards/basis-theory/tokenize', "POST", {
                    token: tokenId,
                    cardNumber: `{{ token_intent: ${tokenId} | json: "$.data.number" }}`,
                    expirationDate: `{{ token_intent: ${tokenId} | json: "$.data" | card_exp: "MMYY"  }}`,
                    firstName: this.$refs.tokenizerForm.innerFirstName,
                    lastName: this.$refs.tokenizerForm.innerLastName,
                    address1: this.configuration.FormInputs.Address1.DefaultValue,
                    address2: this.configuration.FormInputs.Address2.DefaultValue,
                    city: this.configuration.FormInputs.Address1.DefaultValue,
                    state: this.configuration.FormInputs.State.DefaultValue,
                    zipCode: this.$refs.tokenizerForm.innerZipCode,
                    phone: this.configuration.FormInputs.Phone.DefaultValue
                }).then((response) => {
                    console.log("Card tokenization response:", response.data);

                    if(response.status) {
                        this.tokenizedCard = response.data;
                        this.tokenizedCard.expirationDate = `${String(this.basisTheoryTokenizedCard.card.expirationMonth).padStart(2, "0")}${String(this.basisTheoryTokenizedCard.card.expirationYear).slice(-2)}`;
                        this.tokenizedCard.cardLastFour = this.basisTheoryTokenizedCard.card.last4;
                        this.tokenizedCard.basis_theory_token = tokenId;

                        this.handleTokenizationSuccess(verifyData);
                    } else {
                        throw new Error("paylianceTokenizeCardviaBT: " + JSON.stringify(response));
                    }

                }).catch((err) => {
                    console.log("Basis Theory Proxy Response", err);
                    this.stopTokenization();
                    throw err;
                })
        },
        paylianceVerifyCardviaBT(tokenId) {
            this.$fnApi.call('/api/v1/cards/basis-theory/verify', "POST", {
                    token: tokenId,
                    cardNumber: `{{ token_intent: ${tokenId} | json: "$.data.number" }}`,
                    expirationDate: `{{ token_intent: ${tokenId} | json: "$.data" | card_exp: "MMYY"  }}`,
                    securityCode: `{{ token_intent: ${tokenId} | json: "$.data.cvv" }}`,
                    firstName: this.$refs.tokenizerForm.innerFirstName,
                    lastName: this.$refs.tokenizerForm.innerLastName,
                    address1: this.configuration.FormInputs.Address1.DefaultValue,
                    address2: this.configuration.FormInputs.Address2.DefaultValue,
                    city: this.configuration.FormInputs.Address1.DefaultValue,
                    state: this.configuration.FormInputs.State.DefaultValue,
                    zipCode: this.$refs.tokenizerForm.innerZipCode,
                    phone: this.configuration.FormInputs.Phone.DefaultValue,
                    memo: "New Payliance Card via Basis Theory",
                }).then((response) => {
                    console.log("Card verification response:", response.data);
                    if(response.status) {
                        this.paylianceTokenizeCardviaBT(tokenId, response.data);
                    } else {
                        throw new Error("paylianceVerifyCardviaBT: " + JSON.stringify(response));
                    }
                }).catch((err) => {
                    console.log("Basis Theory Proxy Response", err);
                    this.stopTokenization();
                    throw err;
                })

        },
        onCardTokenError(error) {
            console.error("Error creating card token:", error);
            this.onSubmitting(false);
            const errorMsg = error?.message || error?.msg || error?.error || 'Error creating card token. Please try again.';
            this.$fnNotify({message: errorMsg, type: 'error'});
        },
        onProcessorVerified(payload) {
            if (!payload || !payload.tokenizedCard || !payload.verifyData) {
                this.onSubmitting(false);
                this.$fnNotify({message: 'Invalid processor verification payload', type: 'error'});
                return;
            }
            this.tokenizedCard = payload.tokenizedCard;
            this.handleTokenizationSuccess(payload.verifyData);
        },
        tokenizeCard() {
            this.paylianceIsProcessing = true;
            this.$refs.tokenizerForm.submitCard();
        },
        stopTokenization() {
            this.paylianceIsProcessing = false;
            this.$fnNotify({
                message: "Error occured saving card, please try again or contact support.",
                type: 'error'
            })
        },
        handleTokenizationSuccess(data) {
            this.paylianceIsProcessing = true;

            var cards_url = this.isGuest ? '/api/v1/mobile/guest/cards' : '/api/v1/mobile/cards';

            if(data.successful) {
                if((this.activeTokenizerIsBasisTheory) && !data.bin) {
                    data.bin = this.basisTheoryTokenizedCard.card.bin;
                }

                if((this.activeTokenizerIsPayliance) && !data.bin) {
                    console.log(this.tokenizedCard);
                }

                this.tokenizedCard.tokenizer = this.activeTokenizer;
                this.tokenizedCard.provider = data.provider;
                this.$fnApi.call(cards_url, 'POST', {
                    token : this.tokenizedCard,
                    verificationData: data,
                    reVerificationCardId: this.reVerificationCard?.id ?? null,
                    ssn: this.card_ssn
                }).then(response => {
                    if(response.status) {
                        if(this.redirectAfterTokenization) {
                            this.goToPaymentsTab();
                        } else {
                            this.$emit('card-saved', response)
                        }
                    } else {
                        this.$fnNotify(fnResponseToNotification(response))
                    }
                }).catch(response => {
                    this.$fnNotify(fnResponseToNotification(response))
                }).finally(() => {
                    this.paylianceIsProcessing = false;
                })
            }
        },
        handleTokenizationFailure(data) {
            this.paylianceIsProcessing = true;

            if (!data.successful) {
                this.$fnNotify({
                    message: "Error occured saving card, please try again or contact support.",
                    type: 'error'
                })
                this.paylianceIsProcessing = false;
            }
            this.paylianceIsProcessing = false;
        },

    }

}
